<nb-card size="large" [nbSpinner]="diffTemplateGame.length==0" nbSpinnerSize="medium" nbSpinnerStatus="success" >
  <nb-card-header>
    <div class="row" style="align-items: center;">
      Update References games from template:
      <!--table class="selected_params" *ngIf="diffTemplateGame.length>0">
        <tr class="head">
          <td class="" *ngFor="let neededParam of neededParams; let i=index">
            <nb-checkbox class="label" [checked]="neededParam.checked" (change)="toggle(i)">{{neededParam.label}}</nb-checkbox>
          </td>
        </tr>
      </table-->
    </div>
  </nb-card-header>
  <nb-card-body class="body_item">
    <table *ngIf="diffTemplateGame.length>0">
      <tr class="head">
        <td class="mission_name">Mission</td>
        <td *ngIf="neededParams[0].checked" class="title_params">successMissions</td>
        <td *ngIf="neededParams[1].checked" class="title_params">failMissions</td>
        <td *ngIf="neededParams[2].checked" class="title_params">successObjects</td>
        <td *ngIf="neededParams[3].checked" class="title_params">activateMissions</td>
        <td *ngIf="neededParams[4].checked" class="title_params">activateObjects</td>
        <td *ngIf="neededParams[5].checked" class="title_params">neededObjects</td>
      </tr>
    </table>
    <ng-template ngFor let-diff="$implicit" [ngForOf]="diffTemplateGame" let-i="index">
      <div class="row col-12 mission">
        <div class="title-mission col-11" (click)="toggleShowDetailGame(i)">
          Game : {{diff.gameName.fr}} 
        </div>
        <div class="col-auto arrow-button" (click)="toggleShowDetailGame(i)">
          <nb-icon *ngIf="!gameVisibly[i]" icon="arrow-ios-downward-outline"></nb-icon>
          <nb-icon *ngIf="gameVisibly[i]" icon="arrow-ios-upward-outline"></nb-icon>
        </div>
      </div>
      <table>
        <tbody [@slideInOut] *ngIf="!gameVisibly[i]">
          <tr *ngFor="let change of diff.changes; let j=index">
            <td> <span> {{change.template.missionName}} </span> </td>
            <td *ngIf="neededParams[0].checked"> | </td>
            <td *ngIf="neededParams[0].checked" class="params">
              <span class="id" *ngFor="let successMission of change.template.successMissions" nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="Mission: {{ getTemplateMissionName(templateId, successMission) | txtTranslate}}"> {{successMission}}<br> </span>
            </td>
            <td *ngIf="neededParams[0].checked"><nb-icon nbButton status="success" icon="checkmark-square-2-outline" (click)="applyChange(change.template, change.game, 'successMissions', i, j)"></nb-icon></td>
            <td *ngIf="neededParams[0].checked" class="params">
              <span class="id" *ngFor="let successMission of change.game.successMissions" nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="Mission: {{ getGameMissionName(diff.gameId, successMission) | txtTranslate }}">{{successMission}}<br></span>
            </td>
    
            <td *ngIf="neededParams[1].checked"> | </td>
            <td *ngIf="neededParams[1].checked" class="params">
              <span class="id" *ngFor="let failMission of change.template.failMissions" nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="Mission: {{ getTemplateMissionName(templateId, failMissions) | txtTranslate }}">{{failMission}}</span>
            </td>
            <td *ngIf="neededParams[1].checked"><nb-icon nbButton status="success" icon="checkmark-square-2-outline" (click)="applyChange(change.template, change.game, 'failMissions', i, j)"></nb-icon></td>
            <td *ngIf="neededParams[1].checked" class="params">
              <span class="id" *ngFor="let failMission of change.game.failMissions" nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="Mission: {{ getGameMissionName(diff.gameId, failMissions) | txtTranslate }}"> {{failMission}} </span>
            </td>
    
            <td *ngIf="neededParams[2].checked"> | </td>    
            <td *ngIf="neededParams[2].checked" class="params">
              <span class="id" *ngFor="let successObject of change.template.successObjects" nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="Object: {{ getTemplateObject(templateId, successObject) | txtTranslate}}"> {{successObject}} </span>
            </td>
            <td *ngIf="neededParams[2].checked"><nb-icon nbButton status="success" icon="checkmark-square-2-outline" (click)="applyChange(change.template, change.game, 'successObject', i, j)"></nb-icon></td>
            <td *ngIf="neededParams[2].checked" class="params">
              <span class="id" *ngFor="let successObject of change.game.successObjects" nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="Object: {{ getGameObject(diff.gameId, successObject) | txtTranslate }}"> {{successObject}} </span>
            </td>

            <td *ngIf="neededParams[3].checked"> | </td>
            <!-- activateMissions /  activateObjects / neededObjects   getTemplateMissionName(templateId, missionId) -->
            <td *ngIf="neededParams[3].checked" class="params">
              <span class="id" *ngFor="let forkSelection of change.template.activateMissions[0]"> 
                <span *ngFor="let activateMission of forkSelection.activateMissions" nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="Mission: {{ getTemplateMissionName(templateId, activateMission) | txtTranslate}}"> {{activateMission}} </span>
              </span>
            </td>
            <td *ngIf="neededParams[3].checked"><nb-icon nbButton status="success" icon="checkmark-square-2-outline" (click)="applyChange(change.template, change.game, 'activateMissions', i, j)"></nb-icon></td>
            <td *ngIf="neededParams[3].checked" class="params">
              <span class="id" *ngFor="let forkSelection of change.game.activateMissions[0]"> 
                <span *ngFor="let activateMission of forkSelection.activateMissions" nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="Mission: {{ getGameMissionName(diff.gameId, activateMission) | txtTranslate }}"> {{activateMission}} </span>
              </span>
            </td>

            <td *ngIf="neededParams[4].checked"> | </td>
            <td *ngIf="neededParams[4].checked" class="params">
              <span class="id" *ngFor="let forkSelection of change.template.activateObjects[0]" nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="Object: "> {{forkSelection.activateObjects}} </span>
            </td>
            <td *ngIf="neededParams[4].checked"><nb-icon nbButton status="success" icon="checkmark-square-2-outline" (click)="applyChange(change.template, change.game, 'activateObjects', i, j)"></nb-icon></td>
            <td *ngIf="neededParams[4].checked" class="params">
              <span *ngFor="let forkSelection of change.game.activateObjects[0]" nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="Object:"> {{forkSelection.activateObjects}} </span>
            </td>

            <td *ngIf="neededParams[5].checked"> | </td>
            <td *ngIf="neededParams[5].checked" class="params">
              <span *ngFor="let forkSelection of change.template.neededObjects[0]" nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="Object: "> {{forkSelection.neededObjects}} </span>
            </td>
            <td *ngIf="neededParams[5].checked"><nb-icon nbButton status="success" icon="checkmark-square-2-outline" (click)="applyChange(change.template, change.game, 'neededObjects', i, j)"></nb-icon></td>
            <td *ngIf="neededParams[5].checked" class="params">
              <span *ngFor="let forkSelection of change.game.neededObjects[0]" nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="Object:"> {{forkSelection.neededObjects}} </span>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-template>
  </nb-card-body>
  <nb-card-footer>
      <button class="cancel mr-3" nbButton status="danger" (click)="cancel()">Cancel</button>
      <!--button nbButton status="success" (click)="applyAllChanges()">Apply all changes</button-->
  </nb-card-footer>
</nb-card>